import './App.css';
import { motion } from "motion/react";

const experiences = [
  {
    title: 'PRIMASYS Company • Damascus, Syria',
    period: 'Jan 2023 – Dec 2024',
    description:[
      "Developed responsive frontend interfaces for government service platforms.",
      "Integrated REST APIs with backend services.",
      "Collaborated with backend developers to deliver scalable solutions.",
      "Implemented AI-assisted development workflows to enhance productivity.",
      "Built reusable React components and maintained clean code"
    ],
    delay:'0.2'
  },
  {
    title: 'Freelancer',
    period: 'Mar 2025 – Present',
    description:[
      "Developed custom React-based websites for clients.",
      "Built responsive and mobile-first user interfaces.",
      "Optimized application performance and code maintainability.",
      "Transformed client requirements into modern web solutions."
    ],
    delay:'0.8'
  },
];

function Experience() {
  //mapping
  const experiencesShow=experiences.map((item,key) => (
          <motion.div className="experience-card timeline-item" key={key}
          initial={{ opacity: 0 ,translateX:"-200px" }}
          whileInView={{ opacity: 1, translateX:"0"}}
          transition={{ duration: 1 ,delay:item.delay }}
          viewport={{once:true}}>
            <strong >Frontend Web Developer | <span style={{color:'var(--accent)'}}>{item.title}</span></strong>
            <p style={{color:'#38BDF8'}}>{item.period}</p>
            <ul>
              {item.description.map((desc,key) => (
                <li key={key}>{desc}</li>
              ))}
            </ul>
          </motion.div>
        ))
  return (
    <section id="experience" className="section">
      <div className="section-heading">
        <h2>Experience</h2>
        <p>Professional experience delivering responsive, scalable, and user-focused web applications across company and freelance projects.</p>
      </div>
      <div className="timeline">
        {experiencesShow}
      </div>
    </section>
  );
}

export default Experience;
